<template>
    <section id="mainContent">
      <general-header :headerTitle="'Histórico de ponto'" :headerIcon="['calendar-outline']"></general-header>

      <left-menu></left-menu>

      <shadow-box
        class="list-table"
        v-if="!loadingRequest"
      >
        <div class="list-header">
          <date-picker
          :placeholder="$t('Últimos 30 dias')"
          v-model="timeRange"
          @change="handleChange"
          :disabled-date="(date) => date >= new Date()"
          :clearable="false"
          :range="true"
          >
            <i slot="icon-calendar">
              <ion-icon name="today-outline"></ion-icon>
            </i>
          </date-picker>

          <div class="content-select-wrapper">
            <label for="adjustment-select" class="exception-label">Filtrar por ajustes</label>
            <select name="adjustment" id="adjustment-select" v-model="selectedAdjustment" @change="handleSelectChange">
              <option selected>Todos</option>
              <option>Solicitado</option>
              <option>Aprovado</option>
              <option>Recusado</option>
            </select>
          </div>

          <div class="status-wrapper">
            <button
              :class="[{'occurrences-active': (this.selectedFilter === 'occurrence')}, 'occurrences-button']"
              @click="handleSelectedFilter('occurrence')"
            >
              <ion-icon name="alert-circle-outline"></ion-icon>
              Ocorrências
            </button>

            <button :class="[{'abscence-active': this.selectedFilter === 'abscence'}, 'abscence-button']"
            @click="handleSelectedFilter('abscence')">
              <ion-icon name="close-circle-outline"></ion-icon>
              Falta
            </button>

            <button :class="[{'concluded-active': this.selectedFilter === 'concluded'}, 'concluded-button']"
            @click="handleSelectedFilter('concluded')">
              <ion-icon name="checkmark-circle-outline"></ion-icon>
              Concluído
            </button>
          </div>
        </div>

        <div class="table-last-ten-days-home-card">
          <div class="table-header-last-ten-days-home-card">
            <div id="first-col">Data</div>
            <div id="second-col">Total Trabalhado</div>
            <div id="third-col">Registro de pontos</div>
            <div id="fourth-col">Saldo do dia</div>
            <div id="fifth-col">Ajuste</div>
            <div id="sixth-col">Status do dia</div>
          </div>

          <div class="table-content-last-ten-days-home-card">
            <div class="table-content-last-ten-days-home-card-full" v-if="this.points">
              <div class="content-line" v-for="point, index in points" :key="index" @click="redirectToDayDetails(point.id)">
                <div class="date-box-home-table">
                  {{point.convertPointReference | formatDate}}
                  <span>{{point.convertPointReference | strDayFull}}</span>
                </div>

                <div class="worked-hours-home-table">
                  {{ point.totalWorkedStr }}
                </div>

                <div class="total-points-home-table">
                  {{ `${point.totalPoints} registros` }}
                </div>

                <div class="balance-hours-home-table"  :style="[{'color': point.dayBalance === '00:00' ? '#7E8DA7' : point.isPositive ? '#2AC166' : '#FF445D'}]">
                  {{ point.signal }} {{ point.dayBalance }}
                </div>

                <div class="adjustment-home-table" v-html="checkAdjustmentStatus(point.userPointAdjustmentStatus).text" :style="{color: checkAdjustmentStatus(point.userPointAdjustmentStatus).color}">
                </div>

                <div class="status-home-table">
                  <status class="status-point-history"
                    :data="checkLastTenDaysStatus(point.userPointDayStatus, point.userPointAdjustmentStatus, point.userVacationType)"
                    >
                  </status>
                </div>
              </div>
            </div>
          </div>
        </div>
      </shadow-box>

      <dot-loader v-else></dot-loader>


    </section>
</template>

<script>
import { REQUEST_SERVICE } from '../../../../requestConfig';
import { POINT_HISTORY } from '../../../../urlConfig';
import generalHeader from '../../components/layouts/generalHeader.vue'
import shadowBox from '../../components/layouts/shadowBox.vue'
import LeftMenu from '../../components/leftMenu.vue'
import status from '../../components/status.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { UTIL_SERVICE } from '../../../../utils';
import moment from 'moment';
import DotLoader from '../../components/dotLoader.vue';

export default {
  data() {
    return {
      redirectedFromHome: false,
      occurrenceArr: [],
      absenceArr: [],
      allowanceArr: [],
      concludedArr: [],
      selectedFilter: null,
      // lang: {
      //   formatLocale: {
      //     weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      //     weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      //     months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      //   },
      //   monthFormat: 'MMMM',
      // },
      timeRange: null,
      points: [],
      backupPoints: [],
      reprovedArr: [],
      solicitedArr: [],
      approvedArr: [],
      userInfo: {},
      initDate: '',
      endDate: '',
      loadingRequest: false,
      newArr: [],
      selectedAdjustment: 'Todos',
      clickedTwice: false,
    }
  },
  components: {
    generalHeader,
    LeftMenu,
    shadowBox,
    DatePicker,
    status,
    DotLoader
  },
  name: 'newPointHistory',
  methods: {
    redirectToDayDetails(id) {
      this.$router.push(`/detalhe-do-ponto/${id}/5`)
    },
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today
    },
    handleSelectedFilter(filter) {
      this.selectedFilter = filter;

      if(this.clickedTwice) {
        this.selectedFilter = ''
      }
      switch(this.selectedFilter) {
        case 'occurrence':
          this.clickedTwice = true;
          this.points = this.occurrenceArr;
          break;

        case 'abscence':
          this.clickedTwice = true;
          this.points = this.absenceArr;
          break;

        case 'allowance':
          this.clickedTwice = true;
          this.points = this.allowanceArr;
          break;

        case 'concluded':
          this.clickedTwice = true;
          this.points = this.concludedArr;
          break;

        default:
          this.clickedTwice = false;
          this.points = this.backupPoints;
          break;
      }
    },
    handleSelectChange(event) {
      const { target: { value }} = event;
      switch(true) {
        case value === 'Solicitado':
          this.points = this.solicitedArr;
          break;

        case value === 'Aprovado':
          this.points = this.approvedArr;
          break;

        case value === 'Recusado':
          this.points = this.reprovedArr;
          break;

        default:
          this.points = this.backupPoints;
          break;
      }
    },
    handleChange() {
      this.getPointsFromRange()
    },
    getPoints: function() {
        this.loadingRequest = true;
        this.failRequest = false;
        this.lastAtt = moment(new Date()).format('DD/MM/YYYY HH:mm');

        if(this.timeRange) {
          this.initDate = moment(this.timeRange[0]).format("YYYY-MM-DD")
          this.endDate = moment(this.timeRange[1]).format("YYYY-MM-DD")
        }

        moment.locale('pt-br');

        let url = POINT_HISTORY;
        url += "?c=" + this.userInfo.companyId;
        url += "&u=" + this.userInfo.id;
        url += "&initDate=" + this.initDate;
        url += "&endDate=" + this.endDate;
        url += "&r=12";

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT POINT_HISTORY:", response.data);

          // Check data exist to map
          if (response.data.length) {
            response.data.map((value, index) => {
              value.convertPointReference = this.$options.filters.convertToDayMothYear(value.pointReference);
              this.points = [...this.points, value];

              // if (index + 1 === response.data.length) {
              //   if (!this.isSearch) {
              //     UTIL_SERVICE.saveStorage('pointHistoryCtrl', {
              //       getRequest: false,
              //       initDate: this.initDate,
              //       endDate: this.endDate,
              //       listHistory: this.listPoint,
              //       dateAtt: moment(new Date()).format('DD/MM/YYYY HH:mm'),
              //       controlBy4Hours: new Date(moment().add(4, 'hours').format()).getTime()
              //     });
              //   }

                this.loadingRequest = false;
                this.firstLoading = false;
            });

            this.backupPoints = this.points;

            this.filterByAdjustment();
            this.filterByStatus();

            if(this.redirectedFromHome) {
              this.points = this.occurrenceArr;
            }
          } else {
            this.loadingRequest = false;
            this.showLoadMore = false;
            this.firstLoading = false;
          }

        }).catch(reason => {
          this.failRequest = true;
          this.loadingRequest = false;
        });
    },
    filterByAdjustment() {
      this.solicitedArr = this.points.filter((e) => {
        return e.userPointAdjustmentStatus === 1;
      })

      this.reprovedArr = this.points.filter((e) => {
        return e.userPointAdjustmentStatus === 3;
      })

      this.approvedArr = this.points.filter((e) => {
        return e.userPointAdjustmentStatus === 2;
      })
    },
    filterByStatus() {
      this.occurrenceArr = this.points.filter((e) => {
        return e.userPointDayStatus === 4;
      })

      this.absenceArr = this.points.filter((e) => {
        return e.userPointDayStatus === 5;
      })

      this.allowanceArr = this.points.filter((e) => {
        return e.userPointDayStatus === 6;
      })

      this.concludedArr = this.points.filter((e) => {
        return e.userPointDayStatus === 3;
      })
    },
    getPointsFromRange: function() {
        this.loadingRequest = true;
        this.failRequest = false;
        this.lastAtt = moment(new Date()).format('DD/MM/YYYY HH:mm');
        this.newArr = [];

        if(this.timeRange) {
          this.initDate = moment(this.timeRange[0]).format("YYYY-MM-DD")
          this.endDate = moment(this.timeRange[1]).format("YYYY-MM-DD")
        }

        moment.locale('pt-br');

        let url = POINT_HISTORY;
        url += "?c=" + this.userInfo.companyId;
        url += "&u=" + this.userInfo.id;
        url += "&initDate=" + this.initDate;
        url += "&endDate=" + this.endDate;
        url += "&r=12";

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT POINT_HISTORY:", response.data);

          // Check data exist to map
          if (response.data.length) {
            response.data.map((value, index) => {
              value.convertPointReference = this.$options.filters.convertToDayMothYear(value.pointReference);
              this.newArr = [...this.newArr, value]
            });
            this.loadingRequest = false;
            this.firstLoading = false;
          } else {
            this.loadingRequest = false;
            this.showLoadMore = false;
            this.firstLoading = false;
          }
          this.points = this.newArr;
          this.backupPoints = this.points;

          this.filterByAdjustment();
          this.filterByStatus();
        }).catch(reason => {
          this.failRequest = true;
          this.loadingRequest = false;
          // this.$toast.error(reason.response.data.erros)
          // Show errors.
        });
    },
    checkLastTenDaysStatus(status1, status2, status3) {
          switch(true) {
            case status3 === 1 || status3 === 11:
              return {
                backgroundColor: '#A313BB',
                text: 'Férias',
                icon: 'airplane'
              }

              case status3 > 0 && (status3 !== 1 || status3 !== 11):
              return {
                backgroundColor: '#7E8DA7',
                text: 'Afastamento',
                icon: 'checkmark-circle'
              }
            case status2 === 1:
              return {
                backgroundColor: '#FFAB2D',
                text: 'Solicitado',
                icon: 'build'
              }

            case status2 === 2:
              return {
                backgroundColor: '#2AC166',
                text: 'Aprovado',
                icon: 'build'
              }

            case status2 === 3:
              return {
                backgroundColor: '#FF445D',
                text: 'Recusado',
                icon: 'build'
              }

            case status1 === 3:
              return {
                backgroundColor: '#2AC166',
                text: 'Concluído',
                icon: 'checkmark-circle'
              }

            case status1 === 4:
              return {
                backgroundColor: '#FFAB2D',
                text: 'Ocorrência',
                icon: 'warning'
              }

            case status1 === 5:
              return {
                backgroundColor: '#FF445D',
                text: 'Falta',
                icon: 'remove-circle'
              }
            default:
              return {
                backgroundColor: '#1b59f8',
                text: 'Dia atual',
                icon: 'today'
              }
          }
    },
    checkAdjustmentStatus(status) {
      switch(true) {
        case status === 1:
          return {
            text: 'Solicitado',
            color: '#FF9900'
          }

        case status === 2:
          return {
            text: 'Aprovado',
            color: '#2AC166'
          }

        case status === 3:
          return {
            text: 'Reprovado',
            color: '#FF445D'
          }
        default:
          return {
            text: '--'
          }
      }
    }
  },
  beforeMount() {
    this.userInfo = UTIL_SERVICE.getStorage('userInfo');

    this.initDate = moment().subtract(30, 'days').format("YYYY-MM-DD");
    this.endDate = moment().format("YYYY-MM-DD");
    this.getPoints();

    this.redirectedFromHome = UTIL_SERVICE.getStorage('redirectedFromHome');

    if(this.redirectedFromHome) {
      this.selectedFilter = 'occurrence';
      this.handleSelectedFilter('occurrence');
      localStorage.removeItem('redirectedFromHome');
    }
  },
  filters: {
    convertToDayMothYear: (value) => {
      if (value) {
        let year = value.toString().substring(0, 4);
        let month = value.toString().substring(4, 6);
        let day = value.toString().substring(6, 8);

        return year + "-" + month + "-" + day;
      } else {
        return "";
      }
    }
  },
}
</script>

<style lang="scss">
#adjustment-select {
    transition: 0.5s;
    background: url("data:image/svg+xml,<svg height='10px' width='10px' viewBox='0 0 16 16' fill='%23E1E1E1' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>") no-repeat !important;
    background-color: none !important;
    border-radius: 10px !important;
    border: 1px solid var(--border) !important;
    width: 200px;
    height: 36px !important;
    -moz-appearance:none !important;
    -webkit-appearance: none !important;
    appearance: none !important;
    background-position: calc(100% - 0.75rem) center !important;
    cursor: pointer;
  }
  .list-table {
    margin-right: 47px;
    padding: 32px 16px;

    .list-header {
      display: flex;
      padding: 0px 8px;
      align-items: flex-end;
      gap: 16px;
      flex-wrap: wrap;

      .status-wrapper {
        display: flex;
        gap: 5px;

        .occurrences-button {
          border: 1px solid #FF9900;
          color: #FF9900;
        }

        .occurrences-button:hover {
          background-color: rgba(255, 153, 0, 0.1)
        }

        .occurrences-active {
          background-color: #FF9900 !important;
          color: #fff !important;

          ion-icon {
            color: #FFF;
          }
        }

        .abscence-button {
          border: 1px solid #FF445D;
          color: #FF445D;
        }


        .abscence-button:hover {
          background-color: rgba(255, 68, 93, 0.1);
        }

        .abscence-active {
          background-color: #FF445D !important;
          color: #fff !important;

          ion-icon {
            color: #FFF;
          }
        }

        .allowance-button {
          border: 1px solid #1B59F8;
          color: #1B59F8;
        }

        .allowance-button:hover {
          background-color: rgba(27, 89, 248, 0.1);
        }

        .allowance-active {
          background-color: #1B59F8 !important;
          color: #fff !important;

          ion-icon {
            color: #FFF;
          }
        }

        .concluded-button {
          border: 1px solid #2AC166;
          color: #2AC166;
        }

        .concluded-button:hover {
          background-color: rgba(42, 193, 102, 0.1);
        }

        .concluded-active {
          background-color: #2AC166 !important;
          color: #fff !important;

          ion-icon {
            color: #FFF;
          }
        }

        button {
          display: flex;
          padding: 5.087px 11.021px;
          border-radius: 10px;
          justify-content: center;
          align-items: center;
          gap: 3.391px;
          background-color: var(--leftMenuColor);

          ion-icon {
            width: 17px;
            height: 17px;
          }
        }
      }

      .content-select-wrapper {
        position: relative;
        display: flex;
        gap: 5px;
        align-items: center;
        }

      label {
        left: 16px;
      }

      .date-picker-wrapper {
        display: flex;
        width: 300px;
        padding: 6px 13px 6px 12px;
        justify-content: space-between;
        align-items: center;
        gap: 11.5px;
        border-radius: 10px;
        border: 1px solid var(--border);
        background: var(--leftMenuColor);
        position: relative;
        cursor: pointer;

        span {
          position: absolute;
          top: -12px;
          left: 15px;
          background: var(--leftMenuColor);
          color: var(--defaultText)
        }
      }



      .mx-icon-calendar {
        transition: 0.5s;
        color: var(--darkBlue);
        right: 30px;
      }
    }

    .mx-input {
      transition: 0.5s;
      border-radius: 10px !important;
      background-color: var(--leftMenuColor) !important;
      border: 1px solid var(--border);
      color: var(--darkBlue) !important;
      width: 100%;
      cursor: pointer
    }

    .mx-input::placeholder {
      color: var(--darkBlue)
    }

    .table-last-ten-days-home-card {
        width: 100%;
        margin-top: 23px;

        .table-content-last-ten-days-home-card {
          font-size: 14px;
          font-weight: 400;
          display: flex;
          justify-content: center;
          height: 100%;
          flex-direction: column;
          align-items: center;
          gap: 11px;

          .table-content-last-ten-days-home-card-full {
            width: 97%;

            .content-line {
              transition: 0.5s;
              width: 100%;
              border-bottom: 1px solid var(--border);
              display: flex;
              align-items: center;
              position: relative;
              justify-content: space-between;

              .date-box-home-table {
                display: flex;
                flex-direction: column;
                color: var(--text);
                font-size: 11px;
                padding: 8px 0px;
                width: 77.55px;

                .date-name {
                  color:var(--text);
                  font-size: 9px;
                  margin: 0;
                }
              }

              .worked-hours-home-table {
                font-size: 13px;
                color: var(--text);
                width: 98px;
                text-align: center;
              }

              .total-points-home-table {
                color: var(--text);
                width: 106px;
                text-align: center;
              }

              .balance-hours-home-table {
                left: 162px;
                width: 70px;
                text-align: center;
              }

              .adjustment-home-table {
                color: var(--text);
                width: 72px;
                text-align: center;
              }

              .status-home-table {
                border-radius: 10px;
                width: 105px;
                height: 14px;

                .status-point-history {
                  font-size: 12px;
                  width: 105px;
                  flex-wrap: nowrap;
                }
              }
            }

            .content-line:hover {
              cursor: pointer;
              background: rgba(27, 89, 248, .05);
            }

            .content-line:last-child {
              border-bottom: none;
            }
          }

          .table-content-last-ten-days-home-card-empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 40%;
            gap: 11px;
          }
        }

        .table-header-last-ten-days-home-card {
          display: flex;
          width: 97%;
          color: #939699;
          font-size: 11px;
          font-weight: 400;
          position: relative;
          justify-content: space-between;
          margin-bottom: 1px solid var(--border);
          margin-left: 1.5%;
          position: relative;

          #first-col {
            width: 77.55px;
          }

          #second-col {
            width: 98px;
          }

          #third-col {
            width: 106px;
          }

          #fourth-col {
            width: 70px;
            text-align: center;
          }

          #fifth-col {
            width: 72px;
            text-align: center;
          }

          #sixth-col {
            width: 105px;
            text-align: center;
          }

          .bottom-border-table-header-last-ten-days-home-card {
            transition: 0.5s;
            position: absolute;
            width: 97%;
            border-bottom: 1px solid var(--border);
            top: 19px;
            right: 2%;
          }
        }
      }
  }

  .mx-datepicker-main {
    background-color: var(--leftMenuColor) !important;
    background: var(--leftMenuColor) !important;
    border: 1px solid var(--border);
  }

  .mx-calendar {
    border: none !important;
    color: var(--darkBlue) !important;
  }

  .mx-icon-calendar {
    cursor: pointer !important;
  }

  .cell .disabled {
    background-color: black;
  }

</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/pointHistory/newPointHistory.vue